module.exports = "<div class=\"xl_wrap\" id=\"share_pop\" style=\"display:none;position:fixed;height: 100%;width: 100%;top: 0px;z-index: 99999;\"><div class=\"share\"><span class=\"share_arw\"></span><p class=\"text_share\">点击右上角<br>发送给朋友or分享朋友圈哟</p></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/tpl/share.tpl
// module id = 83
// module chunks = 2